// extracted by mini-css-extract-plugin
export default {"alertEventsSearchForm":"alert-events-search-form__alert-events-search-form__Iw44Q","buttonDiv":"alert-events-search-form__button-div__X6Syq"};